import { z } from "zod";

import { OfferDtoSchema } from "../../../dtos/offers";

export const GetOfferRequestPathParamSchema = z.object({
  offerId: z.string().uuid(),
});

export type GetOfferRequestPathParamType = z.infer<
  typeof GetOfferRequestPathParamSchema
>;

export const GetOfferResponseBodySchema = z.object({
  offer: OfferDtoSchema,
});

export type GetOfferResponseBodyType = z.infer<
  typeof GetOfferResponseBodySchema
>;
